<template>
    <b-form @submit.prevent="getTicketsData(formData)">
        <b-form-group :label="$t('general.iin')">
            <b-form-input v-model="formData.dealerIin" :disabled="!!Object.keys(taxpayerInfo).length"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('ticket.txnClientDate')">
            <b-form-select v-model="dateRangeType" :options="dateRangeTypes" v-on:change="dateRangeTypeSelected"></b-form-select>
        </b-form-group>
        <b-form-group :label="$t('general.fromDate')">
            <date-picker v-model="formData.txnClientStartDate" type="datetime" format="DD.MM.YYYY HH:mm:ss"
                    input-class="form-control" :clearable="false" confirm :first-day-of-week="1"
                    :lang="datePickerLocale" width="100%"></date-picker>
        </b-form-group>
        <b-form-group :label="$t('general.toDate')">
            <date-picker v-model="formData.txnClientEndDateForm" type="datetime" format="DD.MM.YYYY HH:mm:ss"
                    input-class="form-control" :clearable="false" confirm :first-day-of-week="1"
                    :lang="datePickerLocale" width="100%"></date-picker>
        </b-form-group>
        <b-form-group v-if="!isOperator" :label="$t('kkm.label')">
            <b-form-select :options="kkmOptions" v-model="formData.ccmSfdNumber">
                <template slot="first">
                    <option :value="null">{{ $t('general.select') }}</option>
                </template>
            </b-form-select>
        </b-form-group>

        <b-form-group v-else-if="isOperator" :label="$t('kkm.kkmSfdNum')">
            <b-form-input v-model="formData.ccmSfdNumber" required/>
        </b-form-group>

        <b-form-group :label="$t('ticket.shiftNumber')">
            <b-form-input v-model="formData.shiftNumber"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('ticket.offlineTicketNumber')">
            <b-form-input v-model="formData.offlineTicketNumber"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('ticket.onlineTicketNumber')">
            <b-form-input v-model="formData.onlineTicketNumber"></b-form-input>
        </b-form-group>
        <b-form-row class="mx-0">
            <b-button type="submit" variant="success" class="ml-auto" :disabled="isDisabled">
                <magnify-icon title="" />&nbsp;{{ $t('general.search') }}
            </b-button>
        </b-form-row>
    </b-form>
</template>

<script>
import AppData from '@/utils/appdata'
import * as Utils from '@/utils/utils';

export default {
    name: 'TicketSearchForm',
    mixins: [ AppData ],
    props: {
        fetch: Function,
        offset: Number,
        taxpayerInfo: Object,
        pageSize: Number,
        setOffset: Function
    },
    data () {
        return {
            dateRangeType: Utils.DateRangeType.LastDay,
            kkmList: [],
            formData: {
                dealerId: this.taxpayerInfo.id,
                dealerIin: this.taxpayerInfo.iin,
                ccmId: null,
                ccmSfdNumber: null,
                shiftNumber: null,
                offlineTicketNumber: null,
                onlineTicketNumber: null,
                txnClientStartDate: null,
                txnClientEndDateForm: null,
                txnClientEndDate: Utils.getEndOfCurrentDay(), // todo
                offset: this.offset,
                pageSize: this.pageSize
            },
            datePickerLocale: this.$store.getters.locale.toLowerCase()
        }
    },
    mounted() {
        this.dateRangeTypeSelected();

        if (!this.isOperator && this.taxpayerInfo != null && this.kkmList.length === 0) {
            this.fetchKkmList();
        }
    },
    computed: {
        kkmOptions() {
            return this.$miscUtil.generateSelectList(this.kkmList, 'sfdNumber', 'factoryNumber')
        },
        dateRangeTypes() {
            return [
                { value: Utils.DateRangeType.LastHour, text: this.$t('general.lastHour') },
                { value: Utils.DateRangeType.Last12Hours, text: this.$t('general.last12Hours') },
                { value: Utils.DateRangeType.LastDay, text: this.$t('general.lastDay') }
            ]
        }
    },
    methods: {
        getTicketsData: function (formData) {
            if (this.offset !== 0) {
                this.setOffset(0)
            } else {
                this.fetch(formData)
            }
        },
        fetchKkmList: function () {
            this.$request.sendRequest(this, this.$appConfig.apiUrls.kkm.getAll,
                { id: this.taxpayerInfo.id }, result => {
                    this.kkmList = result
                }, this.displayAlert)
        },
        dateRangeTypeSelected() {
            const dateRange = Utils.getDateRange(this.dateRangeType);
            
            this.formData.txnClientStartDate = dateRange.start;
            this.formData.txnClientEndDateForm = dateRange.end;
        }
    },
    watch: {
        offset: function (newValue) {
            this.formData.offset = newValue
            this.fetch(this.formData)
        },
        taxpayerInfo: function (newTaxpayerInfo) {
            if (this.formData.dealerIin !== newTaxpayerInfo.iin && this.formData.dealerId !== newTaxpayerInfo.id) {
                this.formData.dealerIin = newTaxpayerInfo.iin
                this.formData.dealerId = newTaxpayerInfo.id
                this.fetchKkmList()
            }
        }
    }
}
</script>
